import { knbrOrderTools } from './kn-br-order-tools.i18n';

export const en = { knbrOrderTools };
